import ItemDeleteModalRenderer from './ItemDeleteModalRenderer';
import ItemPeekRenderer from './ItemPeekRenderer';
import MeetingDndModalRenderer from './MeetingDndModalRenderer';
import shouldCalloutCoverTargetGrid from '../utils/shouldCalloutCoverTargetGrid';
import { observer } from 'mobx-react-lite';
import { store } from 'owa-calendar-module-command';
import { CalendarPrintDialogRenderer } from 'owa-calendar-print';
import {
    CalendarSurfaceItemContextMenu,
    CalendarSurfaceContextMenu,
} from 'owa-calendar-surface-contextmenu-view';
import type { CalendarSurfaceHandle } from 'owa-calendar-surface-core';
import * as React from 'react';

interface ModuleSurfaceRendererProps {
    surfaceHandle: CalendarSurfaceHandle;
}

/**
 * These are the renderers necessary for only surface view types
 */
const surfaceViewTypeRenderers = {
    Open_SurfaceContextMenu: () => <CalendarSurfaceContextMenu />,
    Open_ItemContextMenu: () => <CalendarSurfaceItemContextMenu />,
    Open_ItemDeleteModal: () => <ItemDeleteModalRenderer />,
    Open_MeetingDndModal: () => <MeetingDndModalRenderer />,
    DragItem: () => null,
    Open_ItemPeek: (surfaceHandle: CalendarSurfaceHandle) => (
        <ItemPeekRenderer
            surfaceHandle={surfaceHandle}
            shouldCoverTarget={shouldCalloutCoverTargetGrid}
        />
    ),
    Open_ItemCancelPeek: (surfaceHandle: CalendarSurfaceHandle) => (
        <ItemPeekRenderer
            surfaceHandle={surfaceHandle}
            shouldCoverTarget={shouldCalloutCoverTargetGrid}
        />
    ),
    Open_PrintModal: () => <CalendarPrintDialogRenderer />,
};

/**
 * This component ensures that context menus, item peeks and quick compose popups are mutually exclusive
 * It fixes a race when new user request comes before previous one is completed.
 */
const ModuleSurfaceRenderer = observer(function ModuleSurfaceRenderer(
    props: ModuleSurfaceRendererProps
) {
    if (!store.moduleCommand || store.moduleCommand === null) {
        return null;
    }

    if (surfaceViewTypeRenderers[store.moduleCommand]) {
        return surfaceViewTypeRenderers[store.moduleCommand](props.surfaceHandle);
    }

    return null;
});

export default ModuleSurfaceRenderer;
